import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { URL, handleErrors } from "../../../store/actions/depannageActions"
import { toastApiError } from "../../../store/actions/toastActions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"

const AppBtnDownloadPdf = ({
	apiRoute,
	btnTitle,
	callBack = () => {},
	extraClasses = "",
	disabled = false,
	callBefore = null,
	style = null,
}) => {
	const [loading, setLoading] = useState(false)
	const { token } = useSelector((state) => state.navInfo.login)
	const dispatch = useDispatch()

	const handleDownload = async () => {
		setLoading(true)
		try {
			if (callBefore) {
				await callBefore()
			}
			const response = await fetch(`${URL}${apiRoute}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			await downloadPdfFromResponse(response)
		} catch (error) {
			dispatch(toastApiError(error))
		} finally {
			callBack()
			setLoading(false)
		}
	}
	return (
		<button
			className={style ? undefined : `norm-btn2 ${extraClasses}`}
			style={
				style
					? {
							...style,
							...(loading || disabled
								? { opacity: 0.5, cursor: "default" }
								: {}),
						}
					: undefined
			}
			onClick={handleDownload}
			disabled={loading || disabled}
		>
			{loading ? <FontAwesomeIcon icon={faSync} spin /> : btnTitle}
		</button>
	)
}

export default AppBtnDownloadPdf

// Réponse en erreur (AppError JSON, 500…) : JETTE la Response (handleErrors)
// au lieu de télécharger le corps d'erreur en « document.pdf » ; l'appelant
// toaste via toastApiError (retour client 15.10).
export const downloadPdfFromResponse = async (response) => {
	handleErrors(response)
	const contentDisposition = response.headers.get("Content-Disposition")
	let filename = "document.pdf"
	if (contentDisposition) {
		const filenameMatch = contentDisposition.match(
			/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
		)
		if (filenameMatch && filenameMatch[1]) {
			filename = filenameMatch[1].replace(/['"]/g, "") // Enlever les guillemets
		}
	}

	const blob = await response.blob()
	const url = window.URL.createObjectURL(blob)

	const link = document.createElement("a")
	link.href = url
	link.download = filename
	link.click()

	window.URL.revokeObjectURL(url)
}
